import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosPut from "../axios/axios-put";
import axiosPost from "../axios/axios-post";
import axiosGet from "../axios/axios-get";
import axiosDelete from "../axios/axios-delete";

const BASE_URL = "/installment-condition";

export const InstallmentConditionsAPI = Object.freeze({
  getAll: createAsyncThunk(
    "installment-conditions/get-all",
    async (params, { rejectWithValue }) => {
      try {
        const response = await axiosGet.get(BASE_URL, { params });
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  ),

  getOne: createAsyncThunk(
    "installment-conditions/get-one",
    async (id, { rejectWithValue }) => {
      try {
        const response = await axiosGet.get(`${BASE_URL}/${id}`);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  ),

  create: createAsyncThunk(
    "installment-conditions/create",
    async (data, { rejectWithValue }) => {
      try {
        const response = await axiosPost.post(BASE_URL, data);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  ),

  update: createAsyncThunk(
    "installment-conditions/update",
    async (data, { rejectWithValue }) => {
      try {
        const response = await axiosPut.put(`${BASE_URL}/${data.id}`, data);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  ),

  remove: createAsyncThunk(
    "installment-conditions/remove",
    async (id, { rejectWithValue }) => {
      try {
        const response = await axiosDelete.delete(`${BASE_URL}/${id}`);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  ),
});
